import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-application-error',
  templateUrl: './application-error.component.html',
  styleUrls: ['./application-error.component.scss']
})
export class ApplicationErrorComponent {

  constructor(private location: Location) {
  }

  goBack() {
    this.location.back();
  }

}
